import { Box, Typography, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-theme-material-ui';
import React, { useEffect, useState } from 'react';
import Section from '../../shared/Section/Section';
import ModalBlock from '../../shared/ModalBlock/ModalBlock';
import ConsultationModal from '../../shared/Modals/ConsultationModal';
import { styles } from './styles';
import MaterialsModal from '../../shared/Modals/MaterialsModal';

const formData = {
  title: 'Программа обучения основы Data science',
  subtitle: 'Получить консультацию',
  sentContent: {
    title: 'Заявка на обучение отправлена!',
    message: 'Скоро с вами свяжется куратор',
  },
};

const PrecoursePathToDs = ({ images, leadData }) => {
  const [img, setImg] = useState('howBootcampWorks/content-1400');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMaterialModalOpen, setIsMaterialModalOpen] = useState(false);

  const isLessSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isMoreSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const isMoreLg = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const isLessLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (isMoreLg) {
      setImg('howBootcampWorks/content-1400');
    }
    if (isMoreSm && isLessLg) {
      setImg('howBootcampWorks/content-1200');
    }

    if (isLessSm) {
      setImg('howBootcampWorks/content-500');
    }
  }, [isMoreLg, isLessLg, isMoreSm, isLessSm]);

  return (
    <Section title={'Ваш путь в IT'} withoutBg>
      <Box sx={{ position: 'relative', width: 'fit-content' }}>
        <Box
          sx={{
            ...styles.speechBubble,
            width: {
              xs: '268px',
              md: '374px',
            },
            top: {
              lg: '21%',
              md: '16%',
              sm: '16%',
              xs: '12%',
            },
            left: {
              lg: '3%',
              md: '4%',
              sm: '6%',
              xs: 0,
            },
          }}
        >
          <Typography sx={styles.text} component={'div'}>
            Решили освоить Python, присматриваетесь к Data Science и получили
            <Link
              component={'p'}
              variant="kitPrimary"
              target="_self"
              underline="none"
              onClick={() => {
                setIsModalOpen(false);
                setIsMaterialModalOpen(true);
              }}
            >
              бесплатные материалы для подготовки
            </Link>
          </Typography>
        </Box>

        <Box
          sx={{
            ...styles.speechBubble,
            flexDirection: 'column',
            width: {
              xs: '155px',
              md: '308px',
            },
            top: {
              lg: '26%',
              sm: '34%',
              xs: '39%',
            },
            left: {
              lg: '68%',
              sm: '58%',
              xs: '50%',
            },
          }}
        >
          <Typography
            sx={{ ...styles.text, color: '#4520AB', cursor: 'pointer' }}
            onClick={() => {
              setIsMaterialModalOpen(false);
              setIsModalOpen(true);
            }}
            component="p"
          >
            Запишитесь на курс→&nbsp;
          </Typography>
          <Typography sx={styles.text}>
            «Основы Python (в Data Science)»
          </Typography>
        </Box>

        <Box
          sx={{
            ...styles.speechBubble,
            width: {
              xs: '201px',
              md: '315px',
            },
            top: {
              lg: '52%',
              sm: '53%',
              xs: '52%',
            },
            left: {
              lg: '26%',
              sm: '10%',
              xs: 0,
            },
          }}
        >
          <Typography sx={styles.text}>
            Пройдете вступительное интервью в Эльбрус Буткемп
          </Typography>
        </Box>
        <Box
          sx={{
            ...styles.speechBubble,
            width: {
              xs: '167px',
              md: '315px',
            },
            top: {
              lg: '68%',
              md: '69%',
              xs: '72%',
            },
            right: {
              lg: '13%',
              md: '4%',
              xs: '9%',
            },
          }}
        >
          <Typography sx={styles.text}>
            Освоите востребованную IT‑профессию
          </Typography>
        </Box>
        <Box
          sx={{
            ...styles.speechBubble,
            top: {
              lg: '90%',
              xs: '92%',
            },
            left: {
              lg: '23%',
              xs: '10%',
            },
          }}
        >
          <Typography sx={styles.text}>
            Получите первый оффер — самое интересное впереди!
          </Typography>
        </Box>
        <GatsbyImage image={getImage(images[img])} alt="img" />
      </Box>
      <ModalBlock
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      >
        <ConsultationModal
          extraLeadData={leadData}
          formData={formData}
          buttonLabel="оставить заявку"
          ymSubmitEventTypes={[]}
          myTargetSubmitEventTypes={[]}
        />
      </ModalBlock>
      <ModalBlock
        isOpen={isMaterialModalOpen}
        handleClose={() => setIsMaterialModalOpen(false)}
      >
        <MaterialsModal
          extraLeadData={leadData}
          formData={formData}
          buttonLabel="оставить заявку"
          ymSubmitEventTypes={[]}
          myTargetSubmitEventTypes={[]}
        />
      </ModalBlock>
    </Section>
  );
};

export default PrecoursePathToDs;
